import { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { difference } from 'lodash/fp';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';
import { selectProjectErrorNodeUids } from 'app/store/flow';
import { useSelector, useLocalStorage } from 'app/lib/hooks';
import { LinkButton } from 'app/components/core/LinkButton';
import { selectCurrentProjectId } from 'app/store/projects';
import { initialFilterConfiguration } from 'app/components/features/ProblemsPanel/constants';
import * as styles from './ProjectErrorsNotification.css';

export function ProjectErrorsNotification({ id, onDismiss, existingProjectErrorNodeUids }) {
    const { t } = useTranslation();
    const newProjectErrors = useSelector(selectProjectErrorNodeUids);
    const projectId = useSelector(selectCurrentProjectId);
    const [filterConfiguration, setFilterConfiguration] = useLocalStorage(
        `problems-panel-filters-${projectId}`,
        initialFilterConfiguration
    );
    const [, setIsDrawerExpanded] = useLocalStorage('is-problems-panel-expanded', false);
    const newProjectErrorsCount = newProjectErrors.length;
    const existingProjectErrorsCount = existingProjectErrorNodeUids.length;
    const dismissConditions =
        !newProjectErrorsCount || !(newProjectErrorsCount > existingProjectErrorsCount);

    useEffect(() => {
        if (dismissConditions) {
            onDismiss(id);
        }
    }, [dismissConditions, onDismiss, id]);

    if (dismissConditions) {
        return null;
    }
    const newErrors = difference(newProjectErrors, existingProjectErrorNodeUids);

    const handleClick = () => {
        setIsDrawerExpanded(true);
        setFilterConfiguration({
            ...filterConfiguration,
            nodes: newErrors
        });
        onDismiss(id);
    };

    return (
        <Snackbar id={id} onDismiss={onDismiss} variant={SnackbarVariant.ERROR}>
            <SnackbarMessage>
                {' '}
                <Trans
                    t={t}
                    i18nKey="notifications:ProjectErrors"
                    values={{ count: newErrors.length }}
                    components={{
                        span: (
                            <LinkButton className={styles.error} onClick={handleClick}></LinkButton>
                        )
                    }}
                />
            </SnackbarMessage>
        </Snackbar>
    );
}
